import { Expose, Type } from "class-transformer";
import ModelRange from "@models/v2/ranges/ModelRange";

export default class ModelLightRanges {
	@Expose({ name: "card" })
	@Type(() => ModelRange)
	private readonly _card: ModelRange;
	@Expose({ name: "sbp" })
	@Type(() => ModelRange)
	private readonly _sbp: ModelRange;
	@Expose({ name: "total" })
	@Type(() => ModelRange)
	private readonly _total: ModelRange;

	constructor(card: ModelRange, sbp: ModelRange, total: ModelRange) {
		this._card = card;
		this._sbp = sbp;
		this._total = total;
	}

	public get card(): ModelRange {
		return this._card;
	}

	public get sbp(): ModelRange {
		return this._sbp;
	}

	public get total(): ModelRange {
		return this._total;
	}
}
